import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomTab, CustomTabs } from '../../common/custom-tabs.component';
import DocumentAuthenticationComponent from './document-authentication.component';
import ProductAuthenticationComponent from './product-authentication.component';
import DocumentActiveIcon from "../../../assets/icons/document_authentication_active.png";
import ProductActiveIcon from "../../../assets/icons/product_authentication_active.png";
import DocumentIcon from "../../../assets/icons/document_authentication.png";
import ProductIcon from "../../../assets/icons/product_authentication.png";

function useAuthenticationTab() {
    const [authentication_tab, setAuthenticationTabs] = useState(null);

    function setupTabs() {
        const tabs_default = [
            {
                name: 'Document Authentication',
                icon: DocumentActiveIcon,
                inactiveIcon: DocumentIcon,
                component: <DocumentAuthenticationComponent />
            },
            {
                name: 'Product Authentication',
                icon: ProductActiveIcon, 
                inactiveIcon: ProductIcon,
                component: <ProductAuthenticationComponent />
            }
        ];

        setAuthenticationTabs(tabs_default);
    }

    useEffect(() => { setupTabs(); }, []);

    return authentication_tab;
}

function AuthenticationTabsComponent(props) {
    const tabs = useAuthenticationTab();
    const [value, setValue] = useState(0);

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`scrollable-auto-tabpanel-${index}`}
                aria-labelledby={`scrollable-auto-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    function a11yProps(index) {
        return { id: `scrollable-auto-tab-${index}`, 'aria-controls': `scrollable-auto-tabpanel-${index}` };
    }

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <CustomTabs
                    value={value}
                    onChange={handleChange}
                    sx={{ marginTop: 2 }}
                    indicatorColor="transparent"
                    centered
                >
                    {tabs?.map((tab, index) => (
                        <CustomTab
                            key={index}
                            label={tab.name}
                            icon={<img src={value === index ? tab.icon : tab.inactiveIcon} alt={tab.name} style={{ width: 20, height: 20 }} />}
                            iconPosition="start" 
                            disableRipple
                            {...a11yProps(index)}
                        />
                    ))}
                </CustomTabs>
            </Box>

            {tabs?.map((tab, index) => (
                <TabPanel key={index} value={value} index={index} style={{ padding: '0px' }}>
                    {tab.component}
                </TabPanel>
            ))}
        </Box>
    );
}

export default AuthenticationTabsComponent;
